import type { ActivityViewProps } from '../../core/types/activity.types';
import { PercentGridView } from './PercentGridView';

export function PercentGridActivityView(props: ActivityViewProps<'percent_grid'>) {
  return <PercentGridView payload={props.payload} />;
}
